export default __webpack_public_path__ + "static/media/briefcase.5f715072.svg";